import React from "react";
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";

export const textRegular = `
font-size: 2rem;
@media only screen and (min-width: 2200px) {
    font-size: 2.5rem;
  }
`;

export const navFlex = `
display: flex;
justify-content: space-between;
`;

export const linkFlex = `
display: flex;
align-items: center;
`;
